import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { SessionService } from '../services/session.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private sessionService: SessionService,
    private afAuth: AngularFireAuth
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Check if it's a session-related error
        if (this.sessionService.isSessionError(error)) {
          console.log('🔄 Auth Interceptor: Permission error detected, attempting token refresh before logout');

          // Try to refresh token before giving up
          if (!this.isRefreshing) {
            this.isRefreshing = true;

            return from(this.afAuth.currentUser).pipe(
              switchMap((user) => {
                if (user) {
                  // Force token refresh and retry
                  return from(user.getIdToken(true)).pipe(
                    switchMap(() => {
                      console.log('✅ Auth Interceptor: Token refreshed successfully');
                      this.isRefreshing = false;
                      // Retry the original request with new token
                      return next.handle(req);
                    }),
                    catchError((refreshError) => {
                      console.error('❌ Auth Interceptor: Token refresh failed:', refreshError);
                      this.isRefreshing = false;
                      // Only now trigger session expiration
                      this.sessionService.handleSessionExpiration(false);
                      return throwError(() => error);
                    })
                  );
                } else {
                  this.isRefreshing = false;
                  this.sessionService.handleSessionExpiration(false);
                  return throwError(() => error);
                }
              }),
              catchError((err) => {
                this.isRefreshing = false;
                return throwError(() => error);
              })
            );
          }
        }

        return throwError(() => error);
      })
    );
  }
} 